import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
import { DataSet } from '@antv/data-set';
export default {
  name: 'BarMultid',
  props: {
    title: {
      type: String,
      default: ''
    },
    dataSource: {
      type: Array,
      default: function _default() {
        return [{
          type: 'Jeecg',
          'Jan.': 18.9,
          'Feb.': 28.8,
          'Mar.': 39.3,
          'Apr.': 81.4,
          'May': 47,
          'Jun.': 20.3,
          'Jul.': 24,
          'Aug.': 35.6
        }, {
          type: 'Jeebt',
          'Jan.': 12.4,
          'Feb.': 23.2,
          'Mar.': 34.5,
          'Apr.': 99.7,
          'May': 52.6,
          'Jun.': 35.5,
          'Jul.': 37.4,
          'Aug.': 42.4
        }];
      }
    },
    fields: {
      type: Array,
      default: function _default() {
        return ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'May', 'Jun.', 'Jul.', 'Aug.'];
      }
    },
    height: {
      type: Number,
      default: 254
    }
  },
  data: function data() {
    return {
      adjust: [{
        type: 'dodge',
        marginRatio: 1 / 32
      }]
    };
  },
  computed: {
    data: function data() {
      var dv = new DataSet.View().source(this.dataSource);
      dv.transform({
        type: 'fold',
        fields: this.fields,
        key: 'x',
        value: 'y'
      }); // bar 使用不了 - 和 / 所以替换下

      return dv.rows.map(function (row) {
        row.x = row.x.replace(/[-/]/g, '_');
        return row;
      });
    }
  }
};